import { render, staticRenderFns } from "./ModalAddMember.vue?vue&type=template&id=68754ace&scoped=true&"
import script from "./ModalAddMember.vue?vue&type=script&lang=js&"
export * from "./ModalAddMember.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddMember.vue?vue&type=style&index=0&id=68754ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68754ace",
  null
  
)

export default component.exports